import styled from 'styled-components';
import { inputBg, borderColor, placeHolderBg } from '../../styles/variables';
import { mobileLarge } from '../../styles/mediaqueries'


const getInputStyle = () => {
  return {
    fontFamily: 'GT America Standard',
    fontWeight: 300,
    backgroundColor: inputBg,
    width: '275px',
    bordeRadius: '4px',
    padding: '12px 0 14px 20px',
    border: '1px solid',
    borderRadius: '4px',
    borderColor: borderColor,
    fontSize: '16px',
    lineHeight: '20px',
    marginBottom: '80px',
    appearance: 'none',

    '&:active, &:focus': {
      outline: 'none'
    },

    '::placeholder': {
      color: placeHolderBg
    },

    [mobileLarge]: {
      padding: '10px 0 12px 20px',
      marginBottom: '60px',
    },
  }
}

const getContainerStyle = () => {
  return {
    position: 'relative'
  }
}

export const StyledInput = styled.input(getInputStyle);
export const StyledContainer = styled.div(getContainerStyle);

